import { BeyondWordsPlayerInstance } from "@typings/BeyondWords";

export const scrollFlags = {
  isProgrammatic: false,
};

export const registerPlayerStyleEvents = (
  player: BeyondWordsPlayerInstance,
  avoidScrollOnEnded = false,
) => {
  let isFirstTime = true;
  let skipNextVisibility = false;

  // Called by registerAnalyticsEvents when "closed-by-user"
  const onClosedByUser = () => {
    skipNextVisibility = true;
  };

  player.addEventListener("VisibilityChanged", () => {
    // If the user clicked the close button, don't clobber the state.
    // registerAnalyticsEvents relies on this value to fire "audio_close".
    if (player.widgetStyle === "closed-by-user") {
      return;
    }

    if (skipNextVisibility) {
      skipNextVisibility = false;
      return;
    }

    // skip initial visibility event
    if (isFirstTime) {
      isFirstTime = false;
      return;
    }

    if (player.userInterface) {
      player.widgetStyle = player.userInterface.isVisible ? "none" : "standard";
    }
  });

  player.addEventListener("PlaybackEnded", () => {
    if (!avoidScrollOnEnded) {
      scrollFlags.isProgrammatic = true;

      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }
  });

  player.addEventListener("<any>", () => {
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    document
      .querySelectorAll<HTMLElement>(".bwp .player-title")
      .forEach((el) => {
        el.style.setProperty("font-size", "14px", "important");
        el.style.setProperty("color", "#1E1E1E", "important");
      });
    document
      .querySelectorAll<HTMLElement>(".bwp .duration-in-mins")
      .forEach((el) => {
        el.style.setProperty("font-size", "12px", "important");
        el.style.setProperty("color", "#1E1E1E", "important");
      });
    document
      .querySelectorAll<HTMLElement>(".bwp .playback-time")
      .forEach((el) => {
        el.style.setProperty("font-size", "12px", "important");
      });

    // Playlist styles
    document
      .querySelectorAll<HTMLElement>(
        ".tts-playlist-inline-target.bwp .player-title",
      )
      .forEach((el) => {
        el.style.setProperty("font-size", "12px", "important");
        el.style.setProperty("color", "#01519C", "important");
      });
    document.querySelectorAll<HTMLElement>(".bwp .playlist").forEach((el) => {
      el.style.setProperty("background-color", "#F1F6FB", "important");
    });
    document
      .querySelectorAll<HTMLElement>(
        ".bwp .content-title, .tts-playlist-inline-target.bwp .duration-in-mins, .bwp .number",
      )
      .forEach((el) => {
        el.style.setProperty("color", "#01519C", "important");
      });
    document
      .querySelectorAll<HTMLElement>(".bwp .content-title")
      .forEach((el) => {
        el.style.setProperty("font-size", "14px", "important");
        el.style.setProperty("max-width", "1081px", "important");
        el.style.setProperty("max-height", "max-content", "important");
      });
    document
      .querySelectorAll<HTMLElement>(".bwp .playlist .speaker svg path")
      .forEach((el) => {
        el.setAttribute("fill", "#01519C");
      });
  });

  const element = document.querySelector('[data-testid="article-body"]');

  const styleMap = {
    PlaybackEnded: {
      userSelect: "auto",
      backgroundColor: "#F1F6FB",
      textColor: "#1E1E1E",
      iconColor: "#01519C",
    },
    PlaybackPaused: {
      userSelect: "auto",
      backgroundColor: "#F1F6FB",
      textColor: "#1E1E1E",
      iconColor: "#01519C",
    },
    PlaybackPlaying: {
      userSelect: "none",
      backgroundColor: "#01519C",
      textColor: "#FAFAFA",
      iconColor: "#FAFAFA",
    },
  } as const;

  (Object.keys(styleMap) as Array<keyof typeof styleMap>).forEach((event) => {
    player.addEventListener(event, () => {
      player.backgroundColor = styleMap[event].backgroundColor;

      player.textColor = styleMap[event].textColor;

      player.iconColor = styleMap[event].iconColor;

      if (element) {
        (element as HTMLElement).style.userSelect = styleMap[event].userSelect;
      }
    });
  });

  return { onClosedByUser };
};
